import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { DocumentsOffering } from "../models/documents-offering.model";
import { DocumentsPartialOffering } from "../models/documents-partial-offering.model";


@Injectable({
  providedIn: 'root'
})
export class DocumentsOfferingService {
  private apiUrl = environment.apiUrl;

  constructor(private httpClient: HttpClient) {

  }

  getDocuments(): Observable<DocumentsOffering[]> {
    return this.httpClient.get<DocumentsOffering[]>(`${this.apiUrl}/documents`);
  }

  getDocumentsPDF(documentId: number): Observable<Blob> {
    return this.httpClient.get<Blob>(`${this.apiUrl}/documents/${documentId}/download`, {
      responseType: 'blob' as 'json'
    });
  }

  getDocumentsPartial(): Observable<DocumentsPartialOffering[]> {
    return this.httpClient.get<DocumentsPartialOffering[]>(`${this.apiUrl}/documents/partialschooltranscriptions`);
  }

  getDocumentsPartialPDF(documentPartialId: number): Observable<Blob> {
    return this.httpClient.get<Blob>(`${this.apiUrl}/documents/partialschooltranscriptions/${documentPartialId}/download`, {
      responseType: 'blob' as 'json'
    });
  }

  /*Verifica cÃ³digo documento*/
  checkCode(code: string): Observable<any> {
    return this.httpClient.post<any>(`${this.apiUrl}/documents/validate` , {code});
  }
}
